import type { GetAppIntegrationUsersParams } from "./type";

export const softwareKey = {
  all: (id: string) => ["software", id] as const,
  rule: (id: string) => [...softwareKey.all(id), "rules"] as const,
  setting: (id: string) => [...softwareKey.all(id), "settings"] as const,
  countByCategories: (id: string) =>
    [...softwareKey.all(id), "count-by-categories"] as const,
  users: (id: string) => [...softwareKey.all(id), "users"] as const,
  usersSearch: (id: string, search: GetAppIntegrationUsersParams) =>
    [...softwareKey.users(id), "search", { search }] as const,
  usersRoles: (id: string) => [...softwareKey.users(id), "roles"] as const,
  usersStatuses: (id: string) =>
    [...softwareKey.users(id), "statuses"] as const,

  contract: (id: string) => [...softwareKey.all(id), "contract"] as const,
  overviewUser: (id: string) =>
    [...softwareKey.all(id), "overview/user-and-people"] as const,
  overviewBillingCost: (id: string) =>
    [...softwareKey.all(id), "overview/billing-cost"] as const,
  overviewUserGrowth: (id: string) =>
    [...softwareKey.all(id), "overview/user-growth"] as const,
  overviewMonthlyActiveUserRate: (id: string) =>
    [...softwareKey.all(id), "overview/monthly-active-user-rate"] as const,
  overviewMonthlyCost: (id: string) =>
    [...softwareKey.all(id), "overview/monthly-cost"] as const,
  overviewRenewalDate: (id: string) =>
    [...softwareKey.all(id), "overview/renewal-date"] as const,
  overviewSavingCost: (id: string) =>
    [...softwareKey.all(id), "overview/saving-cost"] as const,
  overviewRecommendedActions: (id: string) =>
    [...softwareKey.all(id), "overview/recommended-actions"] as const,

  // refresh status
  refreshStatus: (id: string) =>
    [...softwareKey.all(id), "refresh-status"] as const,
} as const;
